<template>
  <div>
    <favorite-head-outer></favorite-head-outer>
    <favorite-list></favorite-list>
  </div>
</template>

<script>
import FavoriteHeadOuter from '../../components/modules/Catalog/FavoriteHeadOuter'
import FavoriteList from '../../components/modules/Catalog/FavoriteList'
export default {
  name: 'CatalogPage',
  metaInfo () {
    return {
      title: 'Каталог'
    }
  },
  pageClass: 'catalog-page',
  components: {
    FavoriteHeadOuter,
    FavoriteList
  },
  computed: {
  },
  methods: {
    prepare () {
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style scoped>

</style>
